import React, { useState } from 'react';
import './DemoSection.css';

const DemoSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    city: '',
    profession: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const googleFormUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSeWtHn2PWCiMDi0bdL8oBz365T4Qks-YvnGQwk8L424kLmW5g/formResponse';
    
    const formBody = new FormData();
    
    // Your actual entry IDs - All fields mapped correctly
    formBody.append('entry.212515980', formData.name);       // Name
    formBody.append('entry.672974972', formData.email);      // Email (now included)
    formBody.append('entry.1653123538', formData.phone);     // Phone
    formBody.append('entry.1243975972', formData.company);   // Company
    formBody.append('entry.653524748', formData.city);       // City
    formBody.append('entry.1768227550', formData.profession); // Profession

    try {
      await fetch(googleFormUrl, {
        method: 'POST',
        mode: 'no-cors',
        body: formBody
      });

      // Save to localStorage as backup
      const demoRequests = JSON.parse(localStorage.getItem('civilcadpro_leads') || '[]');
      demoRequests.push({
        ...formData,
        type: 'Demo Request',
        timestamp: new Date().toISOString()
      });
      localStorage.setItem('civilcadpro_leads', JSON.stringify(demoRequests));
      
      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        city: '',
        profession: ''
      });
      
      setTimeout(() => {
        setSubmitted(false);
      }, 5000);
      
    } catch (error) {
      console.error('Error:', error);
      
      // Backup save to localStorage
      const demoRequests = JSON.parse(localStorage.getItem('civilcadpro_leads') || '[]');
      demoRequests.push({
        ...formData,
        type: 'Demo Request (Offline)',
        timestamp: new Date().toISOString()
      });
      localStorage.setItem('civilcadpro_leads', JSON.stringify(demoRequests));
      
      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        city: '',
        profession: ''
      });
      
      setTimeout(() => {
        setSubmitted(false);
      }, 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="demo-section" id="demo">
      <div className="section-header">
        <h2 className="section-title">Book a Demo</h2>
        <p className="section-subtitle">Experience CivilCADPro in action - Fill the form below</p>
      </div>
      
      <div className="demo-container">
        {!submitted ? (
          <form onSubmit={handleSubmit} className="demo-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full name"
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your@civilcadpro.com"
                  className="form-input"
                />
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">Phone Number *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  pattern="[0-9]{10}"
                  placeholder="10-digit mobile number"
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label htmlFor="company">Company / Organization</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Your company name"
                  className="form-input"
                />
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="city">City *</label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  placeholder="Your city"
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label htmlFor="profession">Profession *</label>
                <select
                  id="profession"
                  name="profession"
                  value={formData.profession}
                  onChange={handleChange}
                  required
                  className="form-input form-select"
                >
                  <option value="">Select your profession</option>
                  <option value="Land Surveyor">Land Surveyor</option>
                  <option value="Civil Engineer">Civil Engineer</option>
                  <option value="Architect">Architect</option>
                  <option value="GIS Specialist">GIS Specialist</option>
                  <option value="Construction Manager">Construction Manager</option>
                  <option value="Urban Planner">Urban Planner</option>
                  <option value="Student">Student</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>
            
            <button 
              type="submit" 
              className="submit-btn" 
              disabled={loading}
            >
              {loading ? '⏳ Submitting...' : '📅 Book a Demo Now'}
            </button>
            
            <p className="form-note">
              📞 For immediate assistance, call: <strong>8895391719</strong>
            </p>
          </form>
        ) : (
          <div className="success-message">
            <div className="success-icon">✅</div>
            <h3>Demo Request Received!</h3>
            <p>Thank you for your interest in CivilCADPro!</p>
            <p>Our team will contact you within 24 hours to schedule your demo.</p>
            <p className="contact-note">
              📞 For immediate assistance: <strong>8895391719</strong>
            </p>
            <button 
              className="another-request-btn"
              onClick={() => setSubmitted(false)}
            >
              Submit Another Request
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default DemoSection;